<template>
    <div id="main" class="container">
        <h1 class="text-center">iKNOW</h1>

        <form>
            <div class="form-group">
                <select class="form-control" :class="category" id="category" v-model="category">
                    <option class="red" value="red">Rôzne</option>
                    <option class="orange" value="orange">Ľudská tvorba</option>
                    <option class="blue" value="blue">Osobnosti</option>
                    <option class="green" value="green">Svet</option>
                </select>
            </div>
        </form>

        <b-container>
            <b-row>
                <b-col cols="1" class="points" />
                <b-col class="header">iBet+</b-col>
                <b-col class="header">iKNOW</b-col>
                <b-col class="header">iBet-</b-col>
                <b-col cols="1" class="points" />
            </b-row>

            <b-row v-for="(row, index) in table" v-bind:key="index">
                <b-col cols="1" class="points">{{ row.points }}</b-col>
                <b-col @click="onBetPlus(index)" class="name">{{ name(row.betPlus) }}</b-col>
                <b-col @click="onIknow(index)" class="name" :class="{selectable: selected>=0}">{{ name(row.player) }}</b-col>
                <b-col @click="onBetMinus(index)" class="name">{{ name(row.betMinus) }}</b-col>
                <b-col cols="1" class="points">{{ row.points }}</b-col>
            </b-row>
        </b-container>

        <b-container class="mt-2">
            <b-row>
                <b-col v-for="(player, index) in players" v-bind:key="player.name" cols="4" class="player">
                    <b-row>
                        <b-col @click="selected=index" class="name selectable" :class="{selected : selected==index, disabled : reads==index}" cols="9">{{ player.name}}</b-col>
                        <b-col class="points" cols="3">{{ player.points}}</b-col>
                    </b-row>
                </b-col>
            </b-row>
        </b-container>

        <div class="btn-group w-100 mt-2" role="group">
            <button @click="onReset" type="button" class="btn btn-secondary col">Reset</button>
            <button @click="onReads" type="button" class="btn btn-secondary col">Reads</button>
            <button @click="onPlus" type="button" class="btn btn-secondary col">Knows</button>
            <button @click="onMinus" type="button" class="btn btn-secondary col">Doesn't</button>
        </div>

        <b-alert class="mt-2" :show="errorMessage.length>0" dismissible variant="danger" @dismissed="errorMessage=''">{{errorMessage}}</b-alert>

        <ol reversed>
            <li v-for="(log, index) in logs" v-bind:key="index" class="text-left">{{ log }}</li>
        </ol>
    </div>
</template>

<script>
export default {
    name: "iKnow",
    data: function () {
        return {
            errorMessage: "",
            category: "red",
            selected: -1,
            reads: -1,
            table: [
                { player: -1, points: 3, betPlus: -1, betMinus: -1 },
                { player: -1, points: 3, betPlus: -1, betMinus: -1 },
                { player: -1, points: 2, betPlus: -1, betMinus: -1 },
                { player: -1, points: 2, betPlus: -1, betMinus: -1 },
                { player: -1, points: 1, betPlus: -1, betMinus: -1 },
                { player: -1, points: 1, betPlus: -1, betMinus: -1 }
            ],
            players: [
                { name: "Tato", points: 1 },
                { name: "Tinka", points: 1 },
                { name: "Jakub", points: 1 },
                { name: "Mamka", points: 1 },
                { name: "Matúš", points: 1 },
                { name: "Kika", points: 1 }
            ],
            logs: []
        };
    },
    methods: {
        name: function (index) {
            return index >= 0 ? this.players[index].name : "";
        },

        log: function (text) {
            this.logs.unshift(text);
        },

        error: function (text) {
            this.errorMessage = text;
        },

        addPoints: function (index, points, message) {
            var old = this.players[index].points;
            this.players[index].points += points;
            if (points < 0) {
                this.log(this.players[index].name + " " + message + ": " + old + points + "=" + this.players[index].points);
            } else {
                this.log(this.players[index].name + " " + message + ": " + old + "+" + points + "=" + this.players[index].points);
            }
        },

        onReads: function () {
            this.error("");

            if (this.selected >= 0) {
                this.reads = this.selected;
                this.selected = -1;
                this.addPoints(this.reads, 2, "reads");
            } else {
                this.error("Select some player.");
            }
        },

        onIknow: function (index) {
            this.error("");

            if (this.selected >= 0) {
                this.table.forEach(row => {
                    if (row.player === this.selected) {
                        row.player = -1;
                    }
                });
                this.table[index].player = this.selected;
            } else {
                this.error("Select some player.");
            }
        },

        onBetPlus: function (index) {
            this.error("");

            if (this.selected >= 0) {
                if (
                    this.table[index].player < 0 ||
                    this.table[index].player == this.selected
                ) {
                    this.error("Player cannot bet here.");
                } else {
                    this.table.forEach(row => {
                        if (row.betPlus === this.selected) {
                            row.betPlus = -1;
                        }
                        if (row.betMinus === this.selected) {
                            row.betMinus = -1;
                        }
                    });
                    this.table[index].betPlus = this.selected;
                }
            } else {
                this.error("Select some player.");
            }
        },

        onBetMinus: function (index) {
            this.error("");

            if (this.selected >= 0) {
                if (
                    this.table[index].player < 0 ||
                    this.table[index].player == this.selected
                ) {
                    this.error("Player cannot bet here.");
                } else {
                    this.table.forEach(row => {
                        if (row.betPlus === this.selected) {
                            row.betPlus = -1;
                        }
                        if (row.betMinus === this.selected) {
                            row.betMinus = -1;
                        }
                    });
                    this.table[index].betMinus = this.selected;
                }
            } else {
                this.error("Select some player.");
            }
        },

        onPlus: function () {
            this.error("");

            var ok = false;

            if (this.selected >= 0) {
                this.table.forEach(row => {
                    if (row.player === this.selected) {
                        row.player = -1;
                        this.addPoints(this.selected, row.points, "knows");
                        if (row.betPlus >= 0) {
                            this.addPoints(row.betPlus, 1, "won the bet");
                            row.betPlus = -1;
                        }
                        if (row.betMinus >= 0) {
                            this.addPoints(row.betMinus, -1, "lost the bet");
                            row.betMinus = -1;
                        }

                        ok = true;
                    }
                });

                if (!ok) {
                    this.error("Player not found in table.");
                }
            } else {
                this.error("Select some player.");
            }
        },

        onMinus: function () {
            this.error("");

            var ok = false;

            if (this.selected >= 0) {
                this.table.forEach(row => {
                    if (row.player === this.selected) {
                        this.log(
                            this.players[this.selected].name + " doesn't know."
                        );

                        row.player = -1;
                        if (row.betPlus >= 0) {
                            this.addPoints(row.betPlus, -1, "lost the bet");
                            row.betPlus = -1;
                        }
                        if (row.betMinus >= 0) {
                            this.addPoints(row.betMinus, 1, "won the bet");
                            row.betMinus = -1;
                        }

                        ok = true;
                    }
                });

                if (!ok) {
                    this.error("Player not found in table.");
                }
            } else {
                this.error("Select some player.");
            }
        },

        onReset: function () {
            this.$bvModal
                .msgBoxConfirm("Are you sure?")
                .then(value => {
                    if (value) {
                        this.category = "red";
                        this.selected = -1;
                        this.reads = -1;
                        this.logs = [];
                        this.errorMessage = "";

                        this.players.forEach(player => {
                            player.points = 1;
                        });
                    }
                })
                .catch(err => {
                    this.log(err);
                });
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    @import "node_modules/bootstrap/scss/bootstrap";
    @import "node_modules/bootstrap-vue/src/index.scss";

    $shadow: 2px 0 0 0 #888, 0 2px 0 0 #888, 2px 2px 0 0 #888, 2px 0 0 0 #888 inset,
        0 2px 0 0 #888 inset;

    .container {
        max-width: 600px;
        text-align: center;
    }

    .player {
        box-shadow: $shadow;
    }

    .header {
        box-shadow: $shadow;
        font-weight: bold;
        padding: 0.3rem;
    }

    .name {
        padding: 0.3rem;
        box-shadow: $shadow;
    }

    .points {
        background-color: silver;
        box-shadow: $shadow;
        padding: 0.3rem;
    }

    .selectable {
        cursor: pointer;
    }

    .selected {
        background-color: greenyellow;
    }

    .disabled {
        background-color: gray;
        cursor: default;
    }

    .blue,
    .blue:focus {
        background-color: blue;
        color: white;
    }

    .green,
    .green:focus {
        background-color: greenyellow;
        color: black;
    }

    .red,
    .red:focus {
        background-color: red;
        color: black;
    }

    .orange,
    .orange:focus {
        background-color: orange;
        color: black;
    }
</style>
